import { gql } from '@apollo/client';

export const FETCH_FACILITY_DETAILS = gql`
    query fetchFacilityDetails($companyFilter: CompanyFilter!, $facilityFilter: FacilityFilter) {
        system {
            companies(filter: $companyFilter) {
                id
                facilities(filter: $facilityFilter) {
                    id
                    databaseId
                    name
                    alias
                    ianaTimezone
                    windowsTimezone
                    locale
                    passwordResetFrequencyDays
                    smaxCustomerCode
                    salesForceAccountId
                    facilityCode
                    smaxStaleDataTimeoutSeconds
                    latitude
                    longitude
                    defaultZoomLevel
                    region
                    processDataRetentionInDays
                    type
                    satelliteMapProvider
                    roadMapProvider
                    isActive
                    useImperialUnits
                }
            }
        }
    }
`;
